import { render, staticRenderFns } from "./PlantSummary.vue?vue&type=template&id=3aa21c01&scoped=true"
import script from "./PlantSummary.vue?vue&type=script&lang=js"
export * from "./PlantSummary.vue?vue&type=script&lang=js"
import style0 from "./PlantSummary.vue?vue&type=style&index=0&id=3aa21c01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa21c01",
  null
  
)

export default component.exports